import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AdvancedTable from "../../../../commonComponents/AdvancedTable";
import { useLoggedInApi } from "../../../../api";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import ProjectCreateModal from "../components/ProjectCreateModal";

export default function Projects() {
    const navigate = useNavigate();
    const apiClient = useLoggedInApi();
    const queryClient = useQueryClient();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleSubmit = async (projectData) => {
        try {
            const resource = apiClient.resource('payment/projects');
            await resource.create(projectData);

            // Refresh the table
            queryClient.invalidateQueries(['table', 'payment/projects']);

            // Show success message
            toast.success("Project added successfully");

            return true;
        } catch (error) {
            console.error("Error adding project:", error);
            toast.error("Failed to add project. Please try again.");
            throw error;
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <h3 className="page-header pb-2">Project Management</h3>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    Manage projects and their financial aspects. Track project budgets, expenses, and revenue.
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                    <Button color="info-outline" onClick={toggleModal}>
                        <FontAwesomeIcon icon={faCirclePlus} />{" "}
                        ADD A PROJECT
                    </Button>
                </Col>
            </Row>

            <AdvancedTable
                friendlyResourceName={"Project"}
                apiResourceName={'payment/projects'}
                columnDefinition={[
                    {
                        name: "Project ID",
                        selector: row => row.ac_id,
                        sortable: true,
                        sortField: 'ac_id'
                    },
                    {
                        name: "Project Name", 
                        selector: row => row.name, 
                        sortable: true,
                        sortField: 'name',
                        grow: 2
                    },
                    {
                        name: "Created Date",
                        selector: row => new Date(row.created_at).toLocaleDateString(),
                        sortable: true,
                        sortField: 'created_at'
                    }
                ]}
            />

            {/* Add Project Modal */}
            <ProjectCreateModal 
                isOpen={isModalOpen} 
                toggle={toggleModal} 
                onSubmit={handleSubmit} 
            />
        </>
    );
}
